import React from "react";
import { connect } from "react-redux";
import DashboardAdd from "../../Components/Layouts/DashboardAdd";
import CategoryTypeForm from "../../Components/Forms/CategoryTypeForm";
import { createEntity, updateEntityInfo, setUpdatedRecentlyToFalse } from "../../Redux/CategoryTypeForm/actions";
import { getEntityById } from "../../Redux/CategoryType/actions";
import { useParams } from "react-router";


function CategoryTypeUpdate({ useAuth, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm }) {  
  let params = useParams();
  console.log(data)
  return (
    <DashboardAdd useAuth={useAuth}>
        <CategoryTypeForm
          isUpdateForm
          {...{params, getEntityById, createEntity, updateEntityInfo, setUpdatedRecentlyToFalse, data, loginData, selectedForm}}
        />
    </DashboardAdd>
  );
}

const mapStateToProps = (state) => {
  return {
    data: state.categoryType,
    selectedForm: state.categoryTypeForm,
    loginData: state.loginData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getEntityById: (tokenData, id) => dispatch(getEntityById(tokenData, id)),
    createEntity: (formData, tokenData, exitAfter, history) => dispatch(createEntity(formData, tokenData, exitAfter, history)),
    updateEntityInfo: (formData, tokenData, id) => dispatch(updateEntityInfo(formData, tokenData, id)),
    setUpdatedRecentlyToFalse: () => dispatch(setUpdatedRecentlyToFalse()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(CategoryTypeUpdate);
